/* eslint-disable camelcase */
import $ from 'jquery'
import * as storage from './storage'

let error_kinds = Object.freeze({
  HTTP_ERROR: Symbol('httpError'),
  JSON_ERROR: Symbol('JSONError'),
  API_ERROR: Symbol('ApiError'),
  NO_ERROR: Symbol('NoError'),
  UNDEFINED_ERROR: Symbol('UndefinedError')
})

function create_srv_error (srv_error) {
  srv_error.type = 'SRV_ERROR'

  // INTENTION: Gæta þess að kind sé alltaf til staðar.
  if (Object.values(error_kinds).every((kind) => { return srv_error.kind !== kind }) === true) {
    srv_error.kind = error_kinds.UNDEFINED_ERROR
  }

  // INTENTION: Búa til villuboð, út frá villukóða frá vefþjónustu.
  var des = ''
  switch (srv_error.kind) {
    case error_kinds.HTTP_ERROR:
      des = 'Netsamskipti gengu ekki.'
      break
    case error_kinds.JSON_ERROR:
      des = 'Samskipti við netþjón voru óeðlileg.<br>Json villa!'
      break
    case error_kinds.API_ERROR:
      switch (srv_error.error_code) {
        case 'SIGNIN_EXCEPTION':
          des = 'Innskráning tókst ekki.'
          break
        case 'ANOTHER_DEVICE_IS_LISTENING':
          des = 'Ó nei.\nNúna er annar notandi að hlusta á bókina þína!\nReyndu síðar.'
          break
        default:
          des = `Villutexta vantar fyrir ERROR_CODE (${srv_error.errorcode}`
      }
      break
    case error_kinds.UNDEFINED_ERROR:
      des = 'Óskilgreind villa!'
      break
  }
  // INTENTION: Til varúðar, þetta á ekki að geta komið upp!
  if (des === '') {
    des = `Villa ekki skilgreind! ${srv_error}`
  }

  // INTENTION: Set saman villuboðin.
  if (srv_error.error_text) {
    srv_error.error_text = `${des}<br>${srv_error.error_text}`
  } else {
    srv_error.error_text = des
  }

  // console.log('SRV create_srv_error', srv_error)
  return srv_error
}

// axios.defaults.baseURL = 'https://hlusta.forlagid.is/'
// axios.defaults.baseURL = 'http://localhost:8099/'
// axios.defaults.headers.post['Content-Type'] = 'application/json'
// $.ajaxSetup({
// })
function post (func, data_request, resolve, reject) {
  let baseUrl = 'https://hlusta.forlagid.is/'
  // let baseUrl = 'https://dev.hlusta.forlagid.is/'
  // let baseUrl = 'http://localhost:8099/'
  let path = baseUrl + 'api/ui/'
  if (storage.get_browser_id()) {
    data_request.browser_id = storage.get_browser_id()
  }
  if (storage.get_user_id()) {
    data_request.user_id = storage.get_user_id()
  }
  // console.log(data_request)
  try {
    // axios.post(
    //     path + func,
    //     JSON.stringify(data_request), {
    //       'Content-Type': 'application/json'
    //     }
    //   )
    $.ajax({
      url: path + func,
      type: 'POST',
      data: JSON.stringify(data_request),
      dataType: 'json'
    })
      .done(api_resp => {
        // console.log('SRV', api_resp)
        if (!api_resp.RESULT) {
          // console.log('SRV A')
          reject(create_srv_error({kind: error_kinds.JSONError, error_text: 'Vantar RESULT.'}))
        } else if (api_resp.RESULT === 'SUCCESS') {
          if (api_resp.hasOwnProperty('DATA')) {
            // console.log('SRV RESOLVED')
            resolve(api_resp.DATA)
          } else {
            // console.log('SRV B')
            resolve({})
            // reject(create_srv_error({kind: error_kinds.JSONError, error_text: 'Vantar DATA.'}))
          }
        } else if (api_resp.RESULT === 'ERROR') {
          if (!api_resp.ERROR_CODE) {
            // console.log('SRV C')
            reject(create_srv_error({kind: error_kinds.JSONError, error_text: 'Vantar ERROR_CODE.'}))
          } else {
            // console.log('SRV D')
            reject(create_srv_error({kind: error_kinds.API_ERROR, error_code: api_resp.ERROR_CODE}))
          }
        }
      })
      .fail(err => {
        // console.log('SRV FAIL', err)
        if (err.response) {
          reject(create_srv_error({kind: error_kinds.HTTP_ERROR, error_text: `Statuscode: ${err.response.status}<br>Message: ${err.response.message}`}))
        } else {
          reject(create_srv_error({kind: error_kinds.HTTP_ERROR, error_text: err.statusText}))
        }
      })
  } catch (e) {
  }
}

export function signin_browser () {
  return new Promise((resolve, reject) => {
    post('signin_browser', {}, resolve, reject)
  })
}

export function signin (username, password) {
  return new Promise((resolve, reject) => {
    post('signin', {username: username, password: password}, resolve, reject)
  })
}

export function signout_browser () {
  return new Promise((resolve, reject) => {
    post('signout_browser', {}, resolve, reject)
  })
}

export function get_assets () {
  return new Promise((resolve, reject) => {
    post('get_assets', {}, resolve, reject)
  })
}

export function get_paths (asset_id) {
  return new Promise((resolve, reject) => {
    post(`get_paths/${asset_id}`, {}, resolve, reject)
  })
}

export function save_current_time (asset_id, path_id, sec_pos) {
  return new Promise((resolve, reject) => {
    post(`save_pos/${asset_id}/${path_id}/${sec_pos}`, {}, resolve, reject)
  })
}



// WEBPACK FOOTER //
// ./src/srv.js